var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTextPaper(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    clipRule: "evenodd",
    viewBox: "0 0 1557 472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M775.775 447.608H810.537V471.871H775.775z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.205-.7H.057V0h.156c.114 0 .176-.062.176-.177v-.024c0-.092-.028-.144-.094-.164v-.002C.351-.386.374-.432.374-.51v-.013C.374-.638.315-.7.205-.7zm-.004.098c.046 0 .067.026.067.083v.023c0 .059-.021.085-.072.085H.163v-.191h.038zm.003.289c.056 0 .079.028.079.09v.039c0 .059-.023.086-.074.086H.163v-.215h.041z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(649.129 5297.7) scale(88.4358)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.163-.7H.057V0H.34v-.1H.163v-.6z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(686.007 5297.7) scale(88.4358)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(717.048 5297.7) scale(88.4358)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.209-.71c-.103 0-.163.062-.163.168v.384c0 .106.06.168.163.168.104 0 .165-.062.165-.168v-.084L.272-.247v.078c0 .056-.021.081-.06.081-.039 0-.06-.025-.06-.071v-.382c0-.046.021-.071.06-.071.039 0 .06.025.06.081v.057l.102-.005v-.063C.374-.648.313-.71.209-.71z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(753.306 5297.7) scale(88.4358)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.423-.7H.312l-.147.292H.163V-.7H.057V0h.106v-.216l.046-.09L.313 0h.113L.279-.422.423-.7z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(789.3 5297.7) scale(88.4358)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(826.62 5297.7) scale(88.4358)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(859.783 5297.7) scale(88.4358)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(896.484 5297.7) scale(88.4358)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.355-.7H.057V0h.298v-.098H.163v-.208h.155v-.098H.163v-.198h.192V-.7z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(932.477 5297.7) scale(88.4358)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(966.79 5297.7) scale(88.4358)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.205-.7H.057V0h.156c.114 0 .176-.062.176-.177v-.024c0-.092-.028-.144-.094-.164v-.002C.351-.386.374-.432.374-.51v-.013C.374-.638.315-.7.205-.7zm-.004.098c.046 0 .067.026.067.083v.023c0 .059-.021.085-.072.085H.163v-.191h.038zm.003.289c.056 0 .079.028.079.09v.039c0 .059-.023.086-.074.086H.163v-.215h.041z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(647.095 5297.7) scale(88.4358)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.163-.7H.057V0H.34v-.1H.163v-.6z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(683.973 5297.7) scale(88.4358)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(715.014 5297.7) scale(88.4358)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.209-.71c-.103 0-.163.062-.163.168v.384c0 .106.06.168.163.168.104 0 .165-.062.165-.168v-.084L.272-.247v.078c0 .056-.021.081-.06.081-.039 0-.06-.025-.06-.071v-.382c0-.046.021-.071.06-.071.039 0 .06.025.06.081v.057l.102-.005v-.063C.374-.648.313-.71.209-.71z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(751.272 5297.7) scale(88.4358)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.423-.7H.312l-.147.292H.163V-.7H.057V0h.106v-.216l.046-.09L.313 0h.113L.279-.422.423-.7z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(787.266 5297.7) scale(88.4358)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(824.586 5297.7) scale(88.4358)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(857.749 5297.7) scale(88.4358)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(894.45 5297.7) scale(88.4358)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.355-.7H.057V0h.298v-.098H.163v-.208h.155v-.098H.163v-.198h.192V-.7z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(930.443 5297.7) scale(88.4358)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(964.756 5297.7) scale(88.4358)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.205-.7H.057V0h.156c.114 0 .176-.062.176-.177v-.024c0-.092-.028-.144-.094-.164v-.002C.351-.386.374-.432.374-.51v-.013C.374-.638.315-.7.205-.7zm-.004.098c.046 0 .067.026.067.083v.023c0 .059-.021.085-.072.085H.163v-.191h.038zm.003.289c.056 0 .079.028.079.09v.039c0 .059-.023.086-.074.086H.163v-.215h.041z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(648.068 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.163-.7H.057V0H.34v-.1H.163v-.6z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(684.945 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(715.986 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.209-.71c-.103 0-.163.062-.163.168v.384c0 .106.06.168.163.168.104 0 .165-.062.165-.168v-.084L.272-.247v.078c0 .056-.021.081-.06.081-.039 0-.06-.025-.06-.071v-.382c0-.046.021-.071.06-.071.039 0 .06.025.06.081v.057l.102-.005v-.063C.374-.648.313-.71.209-.71z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(752.245 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.423-.7H.312l-.147.292H.163V-.7H.057V0h.106v-.216l.046-.09L.313 0h.113L.279-.422.423-.7z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(788.238 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(825.558 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.275-.7H.14L.019 0h.106l.023-.159h.117L.288 0h.108L.275-.7zm-.067.15l.043.295H.162L.205-.55h.003z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(858.722 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.21-.7H.057V0h.106v-.29H.21c.114 0 .176-.062.176-.177v-.056C.386-.638.324-.7.21-.7zm-.004.098c.051 0 .074.027.074.086v.042c0 .059-.023.086-.074.086H.163v-.214h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(895.423 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.355-.7H.057V0h.298v-.098H.163v-.208h.155v-.098H.163v-.198h.192V-.7z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(931.416 5297.7) scale(88.4358)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#451414",
    fillRule: "nonzero",
    d: "M.408 0L.311-.319c.049-.028.075-.08.075-.154v-.05C.386-.638.324-.7.21-.7H.057V0h.106v-.296h.049L.296 0h.112zM.206-.602c.051 0 .074.027.074.086v.036c0 .059-.023.086-.074.086H.163v-.208h.043z",
    transform: "translate(-2672.38 -21717.9) scale(4.16667) translate(965.729 5297.7) scale(88.4358)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M681.804 207.712H702.6619999999999V245.95399999999998H681.804z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff2",
    d: "M885.992 351.258H904.5169999999999V369.78299999999996H885.992z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M0 160.233H22.596V182.829H0z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M1494.34 206.212H1508.115V213.16199999999998H1494.34z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#00fff3",
    d: "M1228.33 25.337H1266.393V46.195H1228.33z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M685.392 447.608H775.779V471.871H685.392z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1508.12 206.212H1556.791V213.16199999999998H1508.12z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1416.69 377.712H1454.932V405.525H1416.69z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M1266.38 25.337H1276.8090000000002V46.195H1266.38z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M427.712 413.55H479.858V448.313H427.712z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M968.104 78.067H1009.821V94.26299999999999H968.104z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff009d",
    d: "M544.313 0H627.746V17.383H544.313z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextPaper);
export default __webpack_public_path__ + "static/media/text-paper.ee268065e3869b760d531d3be6626b3f.svg";
export { ForwardRef as ReactComponent };